import React from 'react'
import Loading from '../../../atoms/loading/loading';
import './mentoriaLoading.scss';

interface MentoriaLoadingProps {
    open: boolean;
}

const MentoriaLoading = ({ open = false }: MentoriaLoadingProps) => {
    return (
        <>
            {open &&
                <div className="mentoria-loading">
                    <div className="mentoria-loading__background"></div>
                    <div className="mentoria-loading__loading">
                        <Loading />
                    </div>
                </div>}
        </>
    )
}

export default MentoriaLoading